import ClickableListItem from 'LuxKit/List/ClickableListItem'
import NavBarMenuItem from 'components/NavKit/NavBarMenuItem/NavBarMenuItem'
import Sheet from 'components/utils/Sheet'
import { rem } from 'polished'
import { useCallback, useState } from 'react'
import styled from 'styled-components'
import zIndex from 'styles/tools/z-index'

interface NavLink {
  label: string
  to?: string
  href?: string
}

interface Props {
  label: string
  items: Array<NavLink>
}

const MenuButtonContainer = styled.div`
  display: inline-block;
  position: relative;
  flex: 0 0 auto;
`

const DropdownContainer = styled(Sheet)`
  position: absolute;
  top: calc(100% + 1px);
  inset-inline-start: 0;
  clip-path: inset(0px -50px -50px -50px);
  width: ${rem(370)};
  z-index: ${zIndex.menu};
`

const DropdownItemsPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(4)};
  padding-block: ${rem(32)};
  padding-inline: ${rem(24)};
`

const DropdownLink = styled(ClickableListItem)`
  && {
    padding: ${rem(12)};
  }
`

function SocieteNavBarMenuButton(props: Props) {
  const { label, items } = props
  const [menuOpen, setMenuOpen] = useState(false)

  const handleMouseEnter = useCallback(() => {
    setMenuOpen(true)
  }, [])

  const handleMouseLeave = useCallback(() => {
    setMenuOpen(false)
  }, [])

  return <MenuButtonContainer
    onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}
  >
    <NavBarMenuItem dropdown>
      {label}
    </NavBarMenuItem>
    {menuOpen && <DropdownContainer background="normal-background" shadow="bottom-medium">
      <DropdownItemsPanel>
        {items.map(item => (
          <DropdownLink
            key={item.label}
            to={item.to}
            href={item.href}
            title={item.label}
            titleColour="normal-contrast"
            size="medium"
          />
        ))}
      </DropdownItemsPanel>
    </DropdownContainer>}
  </MenuButtonContainer>
}

export default SocieteNavBarMenuButton
